import { gsap } from "gsap";

document.addEventListener('DOMContentLoaded',function() {
    
    const storygrid = document.getElementById('storygrid');
    
    const init = function() {
        
        const timeline = document.getElementById('timeline');
        const observerElements = storygrid.querySelectorAll('.js-year');
        const observerOptions = {
            root: null,
            rootMargin: '-25% 0px',
            threshold: 0
        };
        
        const Observer = new IntersectionObserver(
            (entries) => {
                entries.forEach(entry => {
                    if (entry.intersectionRatio > 0) {
                        
                        let id = entry.target.id;
                        
                        if (timeline) {
                            const year = timeline.getElementsByClassName('js-year');
                            for (let i = 0; i < year.length; i++) {
                                year[i].classList.remove('is-active');
                            }
                        }
                        
                        let timeline_current = document.querySelector("a[href='#"+id+"']");

                        timeline_current.classList.add('is-active');
                    }
                });
            }, 
            observerOptions
        );

        observerElements.forEach(el => {
            Observer.observe(el);
        });
    };
    
    //const fadeEl = entry.target.querySelectorAll('.animate-in');
    storygrid ? init() : false;
    
}, false);